import { render, staticRenderFns } from "./ExamineBan.vue?vue&type=template&id=7d0c666c&style=height%3A%20100%25%3B"
import script from "./ExamineBan.vue?vue&type=script&lang=js"
export * from "./ExamineBan.vue?vue&type=script&lang=js"
import style0 from "./ExamineBan.vue?vue&type=style&index=0&id=7d0c666c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports